
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { toLocalTime, toString, compare, utcNow, date as date_3 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { append as append_1, choose, reduce, isEmpty, singleton as singleton_1, sumBy, collect, exists, map, sum, empty as empty_1, take, length, tryHead, contains, filter, ofArray, toArray, sortByDescending } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { DeleteReminder_OpenDialog, ConfirmDialog_ConfirmReminderDialog, EditReminder_OpenDialog, NewReminder_OpenDialog } from "../Dialog/AddReminderDialog.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { StorageId as StorageId_2, DocumentId__get_unwrap, ConsumableId as ConsumableId_1 } from "../../Shared/Shared.js";
import { Msg } from "./Types.js";
import { flatten, map as map_1, defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { TableControl$1, Table } from "../../Widgets/Table/Table.js";
import { ColoredDot } from "../../Components/ColoredDot.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { equals, stringHash, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { split, concat, replace, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Calendar_Warning from "../../../public/assets/icons/Calendar_Warning.svg";
import { FileDialog_LinkedDocumentToolType, FileDialog_LinkedEntityId, Modal_OpenLinkedDocumentModalButtonModalSheet } from "../../Widgets/Modals/LinkedDocumentModal.js";
import { OpenChangelogButtonModalSheet } from "../../Widgets/Modals/ChangelogModal.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import Calendar_Add from "../../../public/assets/icons/Calendar_Add.svg";
import Pencil from "../../../public/assets/icons/Pencil.svg";
import Check from "../../../public/assets/icons/Check.svg";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { TextButton, Button } from "../../Components/Button.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { NewReservation_NewConsumableReservationDialog } from "../Dialog/ReservationFormDialog.js";
import { EditConsumableReservationDialog } from "../Dialog/EditReservationFormDialog.js";
import { DeleteConsumableReservationDialog } from "../Dialog/DeleteReservationDialog.js";
import { TextValue } from "../../Components/Text.js";
import { Helper_historyTypeToTranslationString, ConsumableState, Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { QuickOverviewList } from "../../Widgets/QuickOverviewList.js";
import Following from "../../../public/assets/icons/Following.svg";
import Followers from "../../../public/assets/icons/Followers.svg";
import { AssignConsumableDialog } from "../Dialog/AssignConsumableDialog.js";
import { UnassignConsumableDialog } from "../Dialog/UnassignConsumableDialog.js";
import { ReturnConsumableNotificationDialog } from "../Dialog/ReturnConsumableNotificationDialog.js";
import { SelfServiceAssignConsumableDialog } from "../Dialog/SelfServiceAssignConsumableDialog.js";
import { unwrapStorageId } from "../../Shared/Helper.js";
import { SelfServiceReturnConsumableDialog } from "../Dialog/SelfServiceReturnConsumableDialog.js";
import { StateChangeDialog } from "../Dialog/StateChangeDialog.js";
import Shipment_Check from "../../../public/assets/icons/Shipment_Check.svg";
import Shipment_Delivery_Fail from "../../../public/assets/icons/Shipment_Delivery_Fail.svg";
import { NotificationArea } from "../../Widgets/Notification/NotificationArea.js";
import { NotificationToolType as NotificationToolType_1 } from "../../Widgets/Notification/AcceptNotificationDialog.js";
import { MultipleImageWidget } from "../../Widgets/Image/ImageWidget.js";
import { PropertyList } from "../../Widgets/PropertyListWidget.js";
import { CustomPropertiesPropertyList } from "../../Widgets/CustomPropertiesPropertyList.js";
import { getQueryParams, priceToString } from "../../Common.js";
import { DocumentTable } from "../../Widgets/Table/DocumentTable.js";
import { UploadType as UploadType_2 } from "../../Widgets/Dialogs/FileUploadDialog.js";
import { Helper_displayHistoryComment } from "../../Shared/Changelog.js";
import { AssignmentProtocolDialog, AssignmentProtocolParams } from "../../Widgets/AssignmentProtocol.js";
import { ChangeStockDialog } from "../Dialog/StockChangeDialog.js";
import { StockAddDialog } from "../Dialog/StockAddDialog.js";
import { ChangeStorageSpaceDialog } from "../Dialog/ChangeStorageSpaceDialog.js";
import { SwitchStorageDialog } from "../Dialog/SwitchStorageDialog.js";
import { MinimumStockQuantityDialog } from "../Dialog/MinimumStockQuantityDialog.js";
import { ConsumablesStockPerStorageDeleteDialog } from "../Dialog/ConsumableDeleteStockPerStorageDialog.js";
import Warehouse_1 from "../../../public/assets/icons/Warehouse_1.svg";
import Location_Building_Search from "../../../public/assets/icons/Location_Building_Search.svg";
import Transfer_Cart from "../../../public/assets/icons/Transfer_Cart.svg";
import Notification_Alarm_1 from "../../../public/assets/icons/Notification_Alarm_1.svg";
import { QrCodeTableWithStorage } from "../../Widgets/Table/QrCodeTable.js";
import { ConsumableDeleteDialog } from "../Dialog/ConsumableDeleteDialog.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { Badge } from "../../Components/Badge.js";
import { AreaAnchorMenu } from "../../Widgets/AnchorMenu.js";
import { TableContainerWithTabs, TableContainer, SectionContainer } from "../../Widgets/Container.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { ChangelogTable } from "../../Widgets/Table/ChangelogTable.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initViewConsumable } from "./State.js";

function AppointmentSection(props) {
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsReminderDialogOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setSelectedReminderToConfirm = patternInput_2[1];
    const selectedReminderToConfirm = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsModalOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedReminder = patternInput_4[1];
    const selectedReminder = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const setSelectedDeleteReminder = patternInput_5[1];
    const selectedDeleteReminder = patternInput_5[0];
    const now = date_3(utcNow());
    const reminders = sortByDescending((r) => r.Date, props.Consumable.Reminders, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const xs_3 = toList(delay(() => append(singleton(createElement(NewReminder_OpenDialog, {
        ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsReminderDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(2, []));
        },
    })), delay(() => {
        let IsOpen;
        return append(singleton(createElement(EditReminder_OpenDialog, (IsOpen = (selectedReminder != null), {
            ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
            IsOpen: IsOpen,
            OnClose: () => {
                setSelectedReminder(undefined);
            },
            Reminder: unwrap(selectedReminder),
            SuccessCallback: () => {
                props.Dispatch(new Msg(2, []));
            },
        }))), delay(() => {
            let matchValue, reminder;
            return append((matchValue = selectedReminderToConfirm, (matchValue == null) ? (empty()) : ((reminder = matchValue, append(singleton(createElement(ConfirmDialog_ConfirmReminderDialog, {
                ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                IsOpen: selectedReminderToConfirm != null,
                OnClose: () => {
                    setSelectedReminderToConfirm(undefined);
                },
                Reminder: reminder,
                SuccessCallback: (isFileUploaded) => {
                    props.Dispatch(new Msg(2, []));
                    if (isFileUploaded) {
                        props.Dispatch(new Msg(18, []));
                    }
                },
            })), delay(() => singleton(defaultOf())))))), delay(() => {
                let IsOpen_1;
                return append((selectedDeleteReminder != null) ? singleton(createElement(DeleteReminder_OpenDialog, (IsOpen_1 = (selectedDeleteReminder != null), {
                    ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                    IsOpen: IsOpen_1,
                    OnClose: () => {
                        setSelectedDeleteReminder(undefined);
                    },
                    Reminder: unwrap(selectedDeleteReminder),
                    SuccessCallback: () => {
                        props.Dispatch(new Msg(2, []));
                        props.Dispatch(new Msg(18, []));
                    },
                }))) : empty(), delay(() => {
                    let elems_2;
                    const table = (rows) => {
                        let TableRows, Options;
                        return createElement(Table, (TableRows = toArray(rows), (Options = {
                            BorderStyle: "row",
                            CSVDownload: false,
                            ConfigurableColumns: false,
                            CustomTableFilters: false,
                            DefaultSortColumn: ["date", "desc"],
                            Fullscreen: false,
                            GlobalSearch: false,
                            RowSelection: "singleRow",
                            SaveTableConfiguration: false,
                        }, {
                            ColumnDefinitions: [new ColumnDefinition$1("state", "", t("general.done"), (reminderDate) => {
                                let elems;
                                return reminderDate.IsConfirmed ? (new CellContent(1, [createElement(ColoredDot, {
                                    Color: "green",
                                })])) : ((compare(reminderDate.Date, now) > 0) ? (new CellContent(1, [createElement(ColoredDot, {
                                    Color: "orange",
                                })])) : (new CellContent(1, [reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-5", "w-5"])], (elems = [Calendar_Warning()], ["children", reactApi.Children.toArray(Array.from(elems))])])))])));
                            }, "none", "text"), new ColumnDefinition$1("date", "", t("general.planned_date"), (dto) => (new CellContent(6, [dto.Date])), "dateRange", "date"), new ColumnDefinition$1("executionDate", "", t("general.execution_date"), (dto_1) => (new CellContent(6, [dto_1.ExecutionDate])), "dateRange", "date"), new ColumnDefinition$1("name", "", t("general.name"), (dto_2) => (new CellContent(0, [dto_2.Title])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_3) => (new CellContent(0, [dto_3.Description])), "none", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_4) => (new CellContent(0, [dto_4.ConfirmationComment])), "none", "text"), new ColumnDefinition$1("hasDocumentLinked", "", t("document_reminder_relation.documents_link"), (dto_5) => (new CellContent(1, [createElement(Modal_OpenLinkedDocumentModalButtonModalSheet, {
                                Documents: filter((doc) => contains(DocumentId__get_unwrap(doc.Id), dto_5.DocumentIds, {
                                    Equals: (x_1, y_1) => (x_1 === y_1),
                                    GetHashCode: (x_1) => (stringHash(x_1) | 0),
                                }), props.Documents),
                                LinkedEntityId: new FileDialog_LinkedEntityId(0, [dto_5.Id]),
                                OnClose: () => {
                                    props.Dispatch(new Msg(18, []));
                                    props.Dispatch(new Msg(2, []));
                                },
                                UploadType: new FileDialog_LinkedDocumentToolType(1, [new ConsumableId_1(parse(props.Consumable.Id))]),
                                UserData: props.UserData,
                            })])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_6) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                                EntityId: dto_6.Id,
                            })])), "none", "button")],
                            Controls: toList(delay(() => {
                                let matchValue_1;
                                return append(isFeatureEnabled(new Feature(12, [])) ? ((matchValue_1 = props.UserData.Role, (matchValue_1 === "system") ? singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_8) => {
                                    setIsReminderDialogOpen(true);
                                }, false, false, "table-reminder")) : ((matchValue_1 === "toolManager") ? singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_8) => {
                                    setIsReminderDialogOpen(true);
                                }, false, false, "table-reminder")) : ((matchValue_1 === "user") ? (empty()) : singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_8) => {
                                    setIsReminderDialogOpen(true);
                                }, false, false, "table-reminder")))))) : empty(), delay(() => {
                                    let matchValue_2;
                                    return append((matchValue_2 = props.UserData.Role, (matchValue_2 === "administrator") ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                                        const selectedRow = tryHead(rows_1);
                                        if (selectedRow == null) {
                                        }
                                        else {
                                            const planning = selectedRow;
                                            const matchValue_3 = props.UserData.Role;
                                            switch (matchValue_3) {
                                                case "user": {
                                                    break;
                                                }
                                                default:
                                                    setSelectedReminder(planning);
                                            }
                                        }
                                    }, true, false, "table-edit")) : ((matchValue_2 === "toolManager") ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                                        const selectedRow = tryHead(rows_1);
                                        if (selectedRow == null) {
                                        }
                                        else {
                                            const planning = selectedRow;
                                            const matchValue_3 = props.UserData.Role;
                                            switch (matchValue_3) {
                                                case "user": {
                                                    break;
                                                }
                                                default:
                                                    setSelectedReminder(planning);
                                            }
                                        }
                                    }, true, false, "table-edit")) : ((matchValue_2 === "user") ? (empty()) : singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                                        const selectedRow = tryHead(rows_1);
                                        if (selectedRow == null) {
                                        }
                                        else {
                                            const planning = selectedRow;
                                            const matchValue_3 = props.UserData.Role;
                                            switch (matchValue_3) {
                                                case "user": {
                                                    break;
                                                }
                                                default:
                                                    setSelectedReminder(planning);
                                            }
                                        }
                                    }, true, false, "table-edit"))))), delay(() => {
                                        let matchValue_4;
                                        return append((matchValue_4 = props.UserData.Role, (matchValue_4 === "system") ? singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                            const selectedRow_1 = tryHead(rows_2);
                                            if (selectedRow_1 != null) {
                                                setSelectedReminderToConfirm(selectedRow_1);
                                            }
                                        }, true, false, "table-mark-as-done")) : ((matchValue_4 === "administrator") ? singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                            const selectedRow_1 = tryHead(rows_2);
                                            if (selectedRow_1 != null) {
                                                setSelectedReminderToConfirm(selectedRow_1);
                                            }
                                        }, true, false, "table-mark-as-done")) : ((matchValue_4 === "user") ? (empty()) : singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                            const selectedRow_1 = tryHead(rows_2);
                                            if (selectedRow_1 != null) {
                                                setSelectedReminderToConfirm(selectedRow_1);
                                            }
                                        }, true, false, "table-mark-as-done"))))), delay(() => {
                                            const matchValue_5 = props.UserData.Role;
                                            switch (matchValue_5) {
                                                case "user": {
                                                    return empty();
                                                }
                                                default:
                                                    return singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_3) => {
                                                        const selectedRow_3 = tryHead(rows_3);
                                                        if (selectedRow_3 == null) {
                                                        }
                                                        else {
                                                            const planning_1 = selectedRow_3;
                                                            const matchValue_6 = props.UserData.Role;
                                                            switch (matchValue_6) {
                                                                case "user": {
                                                                    break;
                                                                }
                                                                default:
                                                                    setSelectedDeleteReminder(planning_1);
                                                            }
                                                        }
                                                    }, true, false, "table-delete"));
                                            }
                                        }));
                                    }));
                                }));
                            })),
                            Options: Options,
                            TableKey: "not-defined-table",
                            TableRows: TableRows,
                        })));
                    };
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_2 = toList(delay(() => append(singleton(table((length(reminders) > 5) ? take(5, reminders) : reminders)), delay(() => {
                        let elems_1;
                        return (length(reminders) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems_1 = [createElement(Button, {
                            ComponentState: "enabled",
                            Label: t("general.show_more_data"),
                            OnClick: () => {
                                setIsModalOpen(true);
                            },
                            TestId: "consumable-reminder-showmoredata-button",
                            Variant: "blueButton",
                        }), createElement(ModalSheet, {
                            CloseButtonTestId: "",
                            Content: table(reminders),
                            Controls: empty_1(),
                            IsModalOpen: patternInput_3[0],
                            OnClose: () => {
                                setIsModalOpen(false);
                            },
                            Title: t("general.appointments"),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
                    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                }));
            }));
        }));
    }))));
    return react.createElement(react.Fragment, {}, ...xs_3);
}

function ReservationSection(props) {
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsReservationDialogOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedReservation = patternInput_3[1];
    const selectedReservation = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedDeleteReservation = patternInput_4[1];
    const selectedDeleteReservation = patternInput_4[0];
    const reservations = sortByDescending((r) => r.StartDate, props.Consumable.Reservations, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const xs_2 = toList(delay(() => append(singleton(createElement(NewReservation_NewConsumableReservationDialog, {
        Consumable: props.Consumable,
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsReservationDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(2, []));
        },
        UserData: props.UserData,
    })), delay(() => {
        let matchValue, reservation, IsOpen;
        return append((matchValue = selectedReservation, (matchValue == null) ? (empty()) : ((reservation = matchValue, singleton(createElement(EditConsumableReservationDialog, (IsOpen = (selectedReservation != null), {
            ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
            IsOpen: IsOpen,
            OnClose: () => {
                setSelectedReservation(undefined);
            },
            ReservationId: reservation.Id,
            SuccessCallback: () => {
                props.Dispatch(new Msg(2, []));
            },
            UserData: props.UserData,
        })))))), delay(() => append((selectedDeleteReservation != null) ? singleton(createElement(DeleteConsumableReservationDialog, {
            Consumable: props.Consumable,
            IsOpen: selectedDeleteReservation != null,
            OnClose: () => {
                setSelectedDeleteReservation(undefined);
            },
            Reservation: unwrap(selectedDeleteReservation),
            SuccessCallback: () => {
                props.Dispatch(new Msg(2, []));
            },
            UserData: props.UserData,
        })) : empty(), delay(() => {
            let elems_1;
            const table = (rows) => {
                let TableRows, Options;
                return createElement(Table, (TableRows = toArray(rows), (Options = {
                    BorderStyle: "row",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["startDate", "asc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "singleRow",
                    SaveTableConfiguration: false,
                }, {
                    ColumnDefinitions: [new ColumnDefinition$1("startDate", "", t("general.start_date"), (dto) => (new CellContent(6, [dto.StartDate])), "dateRange", "date"), new ColumnDefinition$1("endDate", "", t("general.end_date"), (dto_1) => (new CellContent(6, [dto_1.EndDate])), "dateRange", "date"), new ColumnDefinition$1("receiverName", "", t("general.receiver"), (dto_2) => (new CellContent(0, [dto_2.ReceiverInformation.ReceiverName])), "none", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (dto_3) => (new CellContent(0, [dto_3.Quantity.toString()])), "text", "text"), new ColumnDefinition$1("storage", "", t("general.storage"), (dto_4) => (new CellContent(0, [dto_4.StorageName])), "select", "text"), new ColumnDefinition$1("reservationName", "", t("general.name"), (dto_5) => (new CellContent(0, [dto_5.Name])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_6) => (new CellContent(0, [dto_6.Description])), "none", "text"), new ColumnDefinition$1("sender", "", t("general.created_by"), (dto_7) => (new CellContent(0, [dto_7.SenderInformation.SenderName])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_8) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: dto_8.Id,
                    })])), "none", "button")],
                    Controls: toList(delay(() => append(isFeatureEnabled(new Feature(12, [])) ? singleton(new TableControl$1(t("dialog.reservation.btn_title"), Calendar_Add(), (_arg_6) => {
                        setIsReservationDialogOpen(true);
                    }, false, false, "table-reservation")) : empty(), delay(() => {
                        let matchValue_1;
                        return append((matchValue_1 = props.UserData.Role, (matchValue_1 === "administrator") ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                            const selectedRow = tryHead(rows_1);
                            if (selectedRow == null) {
                            }
                            else {
                                const planning = selectedRow;
                                const matchValue_2 = props.UserData.Role;
                                switch (matchValue_2) {
                                    case "user": {
                                        if (planning.ReceiverInformation.ReceiverId === props.UserData.UserId) {
                                            setSelectedReservation(planning);
                                        }
                                        break;
                                    }
                                    default:
                                        setSelectedReservation(planning);
                                }
                            }
                        }, true, false, "table-edit")) : ((matchValue_1 === "toolManager") ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                            const selectedRow = tryHead(rows_1);
                            if (selectedRow == null) {
                            }
                            else {
                                const planning = selectedRow;
                                const matchValue_2 = props.UserData.Role;
                                switch (matchValue_2) {
                                    case "user": {
                                        if (planning.ReceiverInformation.ReceiverId === props.UserData.UserId) {
                                            setSelectedReservation(planning);
                                        }
                                        break;
                                    }
                                    default:
                                        setSelectedReservation(planning);
                                }
                            }
                        }, true, false, "table-edit")) : ((matchValue_1 === "user") ? (empty()) : singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                            const selectedRow = tryHead(rows_1);
                            if (selectedRow == null) {
                            }
                            else {
                                const planning = selectedRow;
                                const matchValue_2 = props.UserData.Role;
                                switch (matchValue_2) {
                                    case "user": {
                                        if (planning.ReceiverInformation.ReceiverId === props.UserData.UserId) {
                                            setSelectedReservation(planning);
                                        }
                                        break;
                                    }
                                    default:
                                        setSelectedReservation(planning);
                                }
                            }
                        }, true, false, "table-edit"))))), delay(() => {
                            const matchValue_3 = props.UserData.Role;
                            switch (matchValue_3) {
                                case "user": {
                                    return empty();
                                }
                                default:
                                    return singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_2) => {
                                        const selectedRow_1 = tryHead(rows_2);
                                        if (selectedRow_1 == null) {
                                        }
                                        else {
                                            const planning_1 = selectedRow_1;
                                            const matchValue_4 = props.UserData.Role;
                                            switch (matchValue_4) {
                                                case "user": {
                                                    if (planning_1.ReceiverInformation.ReceiverId === props.UserData.UserId) {
                                                        setSelectedDeleteReservation(planning_1);
                                                    }
                                                    break;
                                                }
                                                default:
                                                    setSelectedDeleteReservation(planning_1);
                                            }
                                        }
                                    }, true, false, "table-delete"));
                            }
                        }));
                    })))),
                    Options: Options,
                    TableKey: "not-defined-table",
                    TableRows: TableRows,
                })));
            };
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(table((length(reservations) > 5) ? take(5, reservations) : reservations)), delay(() => {
                let elems;
                return (length(reservations) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                    ComponentState: "enabled",
                    Label: t("general.show_more_data"),
                    OnClick: () => {
                        setIsModalOpen(true);
                    },
                    TestId: "consumable-reservations-showmoredata-button",
                    Variant: "blueButton",
                }), createElement(ModalSheet, {
                    CloseButtonTestId: "",
                    Content: table(reservations),
                    Controls: empty_1(),
                    IsModalOpen: patternInput_1[0],
                    OnClose: () => {
                        setIsModalOpen(false);
                    },
                    Title: t("navbar.reservation"),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }))));
    }))));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

export function OverviewInformationSection(props) {
    let elems_12;
    const t = useTranslation()[0];
    const countOfUnits = sum(map((stockPerStorage_1) => stockPerStorage_1.Stock, filter((stockPerStorage) => stockPerStorage.IsStockTrackingEnabled, props.Consumable.StockPerStorage)), {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    });
    const countOfUntisString = replace(countOfUnits.toString(), ".", ",");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "ml-5"])], (elems_12 = toList(delay(() => append(singleton(reactElement("div", {
        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
        children: t("general.state"),
    })), delay(() => {
        let elems_1, elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-1"])], (elems = [createElement(ColoredDot, {
            Color: (props.Consumable.State.tag === 1) ? "red" : "green",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextValue, {
            FontWeight: "normal",
            TestId: "",
            Text: concat((props.Consumable.State.tag === 1) ? t("general.retired") : t("general.active"), " ", ...defaultArg(map_1((date) => (("(" + toString(toLocalTime(date), "dd.MM.yyyy")) + ")"), props.Consumable.StateDate), "")),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_2;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-full", "text-sm", "font-semibold", "mb-2"])], (elems_2 = [t("general.name")], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => append(singleton(reactElement("div", {
                className: join(" ", ["mb-2"]),
                children: reactApi.Children.toArray([props.Consumable.MasterData.Name]),
            })), delay(() => {
                let matchValue_2, businessUnitName, elems_4;
                return append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? ((matchValue_2 = props.Consumable.BusinessUnitName, (matchValue_2 == null) ? (empty()) : ((businessUnitName = matchValue_2, append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-full", "text-sm", "font-semibold", "mb-2"])], (elems_4 = [t("business_units.business_unit")], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => singleton(reactElement("div", {
                    className: join(" ", ["mb-2"]),
                    children: reactApi.Children.toArray([businessUnitName]),
                })))))))) : empty()) : empty(), delay(() => {
                    let elems_6;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-full", "text-sm", "font-semibold", "mb-2"])], (elems_6 = [t("general.stock")], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                        let elems_8, elems_7;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_8 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-1"])], (elems_7 = [createElement(ColoredDot, {
                            Color: (countOfUnits === 0) ? "red" : "green",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement(TextValue, {
                            FontWeight: "normal",
                            TestId: "",
                            Text: concat(countOfUntisString, " ", ...t(Helper_unitToTranslationKey(props.Consumable.Unit))),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                            let matchValue_3, lastSeen, elems_10, elems_9;
                            return append((matchValue_3 = props.Consumable.LastSeen, (matchValue_3 == null) ? (empty()) : ((lastSeen = matchValue_3, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_10 = [reactElement("div", {
                                className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                children: t("general.last_seen"),
                            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_9 = [createElement(TextValue, {
                                FontWeight: "normal",
                                TestId: "",
                                Text: `${toString(toLocalTime(lastSeen.ScannedAt), "dd.MM.yyyy HH:mm")} ${t("general.last_seen_by")} ${lastSeen.ScannedByUserName} (${(lastSeen.ScanMethod === "nfc_tag") ? t("general.nfc_tag") : t("general.qr_code")})`,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))))))), delay(() => {
                                let elems_11, Label, Label_1, Label_2, Label_3, Value_3;
                                return isFeatureEnabled(new Feature(3, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_11 = [createElement(QuickOverviewList, {
                                    Currency: props.CustomerConfiguration.Currency,
                                    Elements: {
                                        CommercialData: unwrap(props.Consumable.CommercialData),
                                        Custom: ofArray([(Label = t("consumable.additional_name"), {
                                            Group: t("general.master_data"),
                                            Key: "consumable-additional-name-fav-field",
                                            Label: Label,
                                            Value: props.Consumable.MasterData.AdditionalName,
                                        }), (Label_1 = t("general.description"), {
                                            Group: t("general.master_data"),
                                            Key: "consumable-description-fav-field",
                                            Label: Label_1,
                                            Value: props.Consumable.MasterData.Description,
                                        }), (Label_2 = t("general.inventory_number"), {
                                            Group: t("general.master_data"),
                                            Key: "consumable-inventorynumber-fav-field",
                                            Label: Label_2,
                                            Value: props.Consumable.MasterData.InventoryNumber,
                                        }), (Label_3 = t("general.unit"), (Value_3 = t(Helper_unitToTranslationKey(props.Consumable.Unit)), {
                                            Group: t("general.master_data"),
                                            Key: "consumable-unit-fav-field",
                                            Label: Label_3,
                                            Value: Value_3,
                                        }))]),
                                        CustomProperties: props.Consumable.CustomProperties,
                                    },
                                    IsDialogOpen: props.QuickOverviewDialog.IsOpen,
                                    IsLoading: props.QuickOverviewDialog.IsLoading,
                                    OnSave: (updatedVisibleKeys) => {
                                        props.Dispatch(new Msg(0, [updatedVisibleKeys]));
                                    },
                                    SetDialogOpen: (_arg) => {
                                        props.Dispatch(new Msg(1, []));
                                    },
                                    UserData: props.UserData,
                                    VisibleKeys: props.UserConfiguration.QuickOverviewConfiguration.ConsumableViewVisibleFieldKeys,
                                })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))) : empty();
                            }));
                        }));
                    }));
                }));
            }))));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
}

export function OverviewSection(props) {
    let elems_6;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsAssignDialogOpen = patternInput_1[1];
    const isAssignDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsUnassignDialogOpen = patternInput_2[1];
    const isUnassignDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsChangeStateToRetireDialogOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setIsChangeStateToActiveDialogOpen = patternInput_4[1];
    const patternInput_5 = reactApi.useState(false);
    const setIsReturnNotificationDialogOpen = patternInput_5[1];
    const isReturnNotificationDialogOpen = patternInput_5[0];
    const patternInput_6 = reactApi.useState(false);
    const setIsSelfServiceAssignDialogOpen = patternInput_6[1];
    const isSelfServiceAssignDialogOpen = patternInput_6[0];
    const patternInput_7 = reactApi.useState(false);
    const setIsSelfServiceReturnDialogOpen = patternInput_7[1];
    const isSelfServiceReturnDialogOpen = patternInput_7[0];
    const actionButtons = toList(delay(() => {
        let Label;
        if (props.Consumable.State.tag === 1) {
            return empty();
        }
        else {
            return append(singleton(createElement(TextButton, (Label = t("general.assign"), {
                ComponentState: "enabled",
                Icon: Following(),
                Label: Label,
                OnClick: () => {
                    setIsAssignDialogOpen(true);
                },
                TestId: "consumable-overview-assign-button",
                Variant: "default",
            }))), delay(() => {
                let Label_1;
                return singleton(createElement(TextButton, (Label_1 = t("general.take_back"), {
                    ComponentState: "enabled",
                    Icon: Followers(),
                    Label: Label_1,
                    OnClick: () => {
                        setIsUnassignDialogOpen(true);
                    },
                    TestId: "consumable-overview-unassign-button",
                    Variant: "default",
                })));
            }));
        }
    }));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_6 = toList(delay(() => append(isAssignDialogOpen ? singleton(createElement(AssignConsumableDialog, {
        Consumable: props.Consumable,
        IsOpen: isAssignDialogOpen,
        OnClose: () => {
            setIsAssignDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(2, []));
        },
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isUnassignDialogOpen ? singleton(createElement(UnassignConsumableDialog, {
        ConsumableId: props.Consumable.Id,
        IsOpen: isUnassignDialogOpen,
        OnClose: () => {
            setIsUnassignDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(2, []));
        },
        UserData: props.UserData,
    })) : empty(), delay(() => append(isReturnNotificationDialogOpen ? singleton(createElement(ReturnConsumableNotificationDialog, {
        Consumable: props.Consumable,
        IsOpen: isReturnNotificationDialogOpen,
        OnClose: () => {
            setIsReturnNotificationDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(2, []));
        },
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isSelfServiceAssignDialogOpen ? singleton(createElement(SelfServiceAssignConsumableDialog, {
        Consumable: props.Consumable,
        IsOpen: isSelfServiceAssignDialogOpen,
        OnClose: () => {
            setIsSelfServiceAssignDialogOpen(false);
        },
        SelfServiceStorages: filter((sps) => {
            if (props.CustomerConfiguration.GlobalSelfServiceStorageActive) {
                return true;
            }
            else {
                return exists((s) => {
                    if (unwrapStorageId(s.Id) === sps.StorageId) {
                        if (s.IsSelfService) {
                            return true;
                        }
                        else {
                            return contains(props.UserData.UserId, s.AccessByUser, {
                                Equals: (x, y) => (x === y),
                                GetHashCode: (x) => (stringHash(x) | 0),
                            });
                        }
                    }
                    else {
                        return false;
                    }
                }, props.Storages);
            }
        }, props.Consumable.StockPerStorage),
        SuccessCallback: () => {
            props.Dispatch(new Msg(2, []));
        },
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isSelfServiceReturnDialogOpen ? singleton(createElement(SelfServiceReturnConsumableDialog, {
        Consumable: props.Consumable,
        IsOpen: isSelfServiceReturnDialogOpen,
        OnClose: () => {
            setIsSelfServiceReturnDialogOpen(false);
        },
        SelfServiceStorages: filter((sps_1) => {
            if (props.CustomerConfiguration.GlobalSelfServiceStorageActive) {
                return true;
            }
            else {
                return exists((s_1) => {
                    if (unwrapStorageId(s_1.Id) === sps_1.StorageId) {
                        if (s_1.IsSelfService) {
                            return true;
                        }
                        else {
                            return contains(props.UserData.UserId, s_1.AccessByUser, {
                                Equals: (x_1, y_1) => (x_1 === y_1),
                                GetHashCode: (x_1) => (stringHash(x_1) | 0),
                            });
                        }
                    }
                    else {
                        return false;
                    }
                }, props.Storages);
            }
        }, props.Consumable.StockPerStorage),
        SuccessCallback: () => {
            props.Dispatch(new Msg(2, []));
        },
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => {
        let elems_5, elems_2, elems, elems_1, matchValue_4, elems_4, elems_3, Images, matchValue_5;
        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "pt-8", "pb-10", "rounded", "px-12"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "mb-12"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-4"])], (elems = toList(delay(() => {
            let Label_2;
            const matchValue_1 = props.UserData.Role;
            switch (matchValue_1) {
                case "toolManager":
                case "user":
                    if (contains(props.UserData.UserId, collect((x_2) => x_2, map((sps_2) => sps_2.AssignedUserIds, props.Consumable.StockPerStorage)), {
                        Equals: (x_3, y_2) => (x_3 === y_2),
                        GetHashCode: (x_3) => (stringHash(x_3) | 0),
                    })) {
                        return actionButtons;
                    }
                    else {
                        const isSelfServiceUser = props.CustomerConfiguration.GlobalSelfServiceStorageActive ? true : exists((s_2) => {
                            if (exists((sps_3) => (sps_3.StorageId === unwrapStorageId(s_2.Id)), props.Consumable.StockPerStorage)) {
                                if (s_2.IsSelfService) {
                                    return true;
                                }
                                else {
                                    return contains(props.UserData.UserId, s_2.AccessByUser, {
                                        Equals: (x_4, y_3) => (x_4 === y_3),
                                        GetHashCode: (x_4) => (stringHash(x_4) | 0),
                                    });
                                }
                            }
                            else {
                                return false;
                            }
                        }, props.Storages);
                        return append((isSelfServiceUser && equals(props.Consumable.State, new ConsumableState(0, []))) ? ((sumBy((sps_4) => sps_4.Stock, props.Consumable.StockPerStorage, {
                            GetZero: () => 0,
                            Add: (x_5, y_4) => (x_5 + y_4),
                        }) > 0) ? singleton(createElement(TextButton, (Label_2 = t("general.self_service_assign"), {
                            ComponentState: "enabled",
                            Icon: Following(),
                            Label: Label_2,
                            OnClick: () => {
                                setIsSelfServiceAssignDialogOpen(true);
                            },
                            TestId: "consumable-detail-self-service-assign-button",
                            Variant: "default",
                        }))) : empty()) : empty(), delay(() => {
                            let Label_3, Label_4;
                            return equals(props.Consumable.State, new ConsumableState(0, [])) ? ((isSelfServiceUser && props.CustomerConfiguration.IsStorageSelfServiceUserAuthorisedToReturnToolsWithoutNotification) ? singleton(createElement(TextButton, (Label_3 = t("general.self_service_return"), {
                                ComponentState: "enabled",
                                Icon: Followers(),
                                Label: Label_3,
                                OnClick: () => {
                                    setIsSelfServiceReturnDialogOpen(true);
                                },
                                TestId: "consumable-detail-self-service-return-button",
                                Variant: "default",
                            }))) : singleton(createElement(TextButton, (Label_4 = t("general.request_return"), {
                                ComponentState: "enabled",
                                Icon: Followers(),
                                Label: Label_4,
                                OnClick: () => {
                                    setIsReturnNotificationDialogOpen(true);
                                },
                                TestId: "consumable-detail-return-notification-button",
                                Variant: "default",
                            })))) : empty();
                        }));
                    }
                default:
                    return actionButtons;
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(singleton_1((elems_1 = toList(delay(() => append(singleton(createElement(StateChangeDialog, {
            Consumable: props.Consumable,
            IsOpen: patternInput_3[0],
            NewState: new ConsumableState(1, []),
            OnClose: () => {
                setIsChangeStateToRetireDialogOpen(false);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(2, []));
            },
        })), delay(() => append(singleton(createElement(StateChangeDialog, {
            Consumable: props.Consumable,
            IsOpen: patternInput_4[0],
            NewState: new ConsumableState(0, []),
            OnClose: () => {
                setIsChangeStateToActiveDialogOpen(false);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(2, []));
            },
        })), delay(() => {
            let Label_6, Label_5;
            const matchValue_2 = props.UserData.Role;
            switch (matchValue_2) {
                case "toolManager":
                case "user": {
                    return empty();
                }
                default:
                    return (props.Consumable.State.tag === 1) ? singleton(createElement(TextButton, (Label_6 = t("tool.state_active"), {
                        ComponentState: "enabled",
                        Icon: Shipment_Check(),
                        Label: Label_6,
                        OnClick: () => {
                            setIsChangeStateToActiveDialogOpen(true);
                        },
                        TestId: "consumable-activate-state-button",
                        Variant: "default",
                    }))) : singleton(createElement(TextButton, (Label_5 = t("general.reject"), {
                        ComponentState: "enabled",
                        Icon: Shipment_Delivery_Fail(),
                        Label: Label_5,
                        OnClick: () => {
                            setIsChangeStateToRetireDialogOpen(true);
                        },
                        TestId: "consumable-retired-state-button",
                        Variant: "default",
                    })));
            }
        })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement(NotificationArea, {
            IsCurrentUserStorageResponsible: (matchValue_4 = props.UserData.Role, (matchValue_4 === "system") ? true : ((matchValue_4 === "toolManager") ? exists((sps_5) => contains(props.UserData.UserId, sps_5.AssignedUserIds, {
                Equals: (x_6, y_5) => (x_6 === y_5),
                GetHashCode: (x_6) => (stringHash(x_6) | 0),
            }), props.Consumable.StockPerStorage) : ((matchValue_4 === "user") ? exists((sps_5) => contains(props.UserData.UserId, sps_5.AssignedUserIds, {
                Equals: (x_6, y_5) => (x_6 === y_5),
                GetHashCode: (x_6) => (stringHash(x_6) | 0),
            }), props.Consumable.StockPerStorage) : true))),
            NotificationToolType: new NotificationToolType_1(3, []),
            Notifications: props.Notifications,
            OnUpdate: () => {
                props.Dispatch(new Msg(2, []));
            },
            UserData: props.UserData,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "mb-8"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-16"])], (elems_3 = [createElement(MultipleImageWidget, (Images = map((image) => ({
            ImageUrl: image.ImageUrl,
            Position: image.Position,
        }), props.Consumable.ConsumableImages), {
            CanEditImage: (matchValue_5 = props.UserData.Role, (matchValue_5 === "system") ? true : ((matchValue_5 === "toolManager") ? true : (!(matchValue_5 === "user")))),
            ComponentState: "enabled",
            FormImages: props.ConsumableImages,
            Images: Images,
            OnImagesChanged: (images) => {
                props.Dispatch(new Msg(5, [images]));
            },
            OnSave: () => {
                props.Dispatch(new Msg(6, []));
            },
        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement(OverviewInformationSection, {
            AccountSettings: props.AccountSettings,
            Consumable: props.Consumable,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            QuickOverviewDialog: props.QuickOverviewDialog,
            UserConfiguration: props.UserConfiguration,
            UserData: props.UserData,
        })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
    })))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

export function MasterDataSection(props) {
    let elems_4, elems_3;
    const t = useTranslation()[0];
    return reactElement("div", createObj(singleton_1((elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-20", "h-30"])], (elems_3 = toList(delay(() => {
        let elems_1, Title, elems;
        return append(singleton(reactElement("div", createObj(singleton_1((elems_1 = [createElement(PropertyList, (Title = t("general.master_data"), {
            Properties: ofArray([{
                Label: t("general.name"),
                TestId: "master-data-name",
                Value: props.Consumable.MasterData.Name,
            }, {
                Label: t("consumable.additional_name"),
                TestId: "master-data-additional-name",
                Value: props.Consumable.MasterData.AdditionalName,
            }, {
                Label: t("general.description"),
                TestId: "master-data-description",
                Value: props.Consumable.MasterData.Description,
            }, {
                Label: t("general.inventory_number"),
                TestId: "master-data-inventory-number",
                Value: props.Consumable.MasterData.InventoryNumber,
            }, {
                Label: t("general.unit"),
                TestId: "master-data-unit",
                Value: t(Helper_unitToTranslationKey(props.Consumable.Unit)),
            }]),
            Title: unwrap(Title),
        })), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-8"])], (elems = [createElement(CustomPropertiesPropertyList, {
            Currency: props.Currency,
            CustomProperties: props.Consumable.CustomProperties,
            Title: t("tool.custom_properties"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))), delay(() => {
            let elems_2, Title_2, matchValue_1, matchValue_2, matchValue_3;
            const matchValue = props.Consumable.CommercialData;
            if (matchValue == null) {
                return empty();
            }
            else {
                const commercialData = matchValue;
                return singleton(reactElement("div", createObj(singleton_1((elems_2 = [createElement(PropertyList, (Title_2 = t("general.commercial_data"), {
                    Properties: ofArray([{
                        Label: t("general.supplier"),
                        TestId: "commercial-data-supplier",
                        Value: commercialData.Supplier,
                    }, {
                        Label: t("general.supplier_article_number"),
                        TestId: "commercial-data-supplier-article-number",
                        Value: commercialData.SupplierArticleNumber,
                    }, {
                        Label: t("general.purchase_price"),
                        TestId: "commercial-data-purchase-price",
                        Value: (matchValue_1 = commercialData.PurchasePrice, (matchValue_1 == null) ? "" : priceToString(matchValue_1, props.Currency)),
                    }, {
                        Label: t("general.purchase_date"),
                        TestId: "commercial-data-purchase-date",
                        Value: (matchValue_2 = commercialData.PurchaseDate, (matchValue_2 == null) ? "" : toString(matchValue_2, "dd.MM.yyyy")),
                    }, {
                        Label: t("general.gurantee_date"),
                        TestId: "commercial-data-guarantee-date",
                        Value: (matchValue_3 = commercialData.WarrantyDate, (matchValue_3 == null) ? "" : toString(matchValue_3, "dd.MM.yyyy")),
                    }, {
                        Label: t("general.comment"),
                        TestId: "commercial-data-comment",
                        Value: commercialData.Comment,
                    }]),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])))));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))]))));
}

function DocumentSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => {
        let Documents;
        return append(singleton(createElement(DocumentTable, (Documents = ((length(props.Documents) > 5) ? take(5, props.Documents) : props.Documents), {
            AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                EntityId: DocumentId__get_unwrap(dto.Id),
            })])), "none", "button")),
            Documents: Documents,
            OnDownloadFile: (tupledArg) => {
                props.Dispatch(new Msg(19, [tupledArg[0], tupledArg[1]]));
            },
            UploadSuccessCallback: () => {
                props.Dispatch(new Msg(18, []));
            },
            UploadType: new UploadType_2(1, [props.ConsumableId]),
            UserData: props.UserData,
        }))), delay(() => {
            let elems, Title;
            return (length(props.Documents) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                ComponentState: "enabled",
                Label: t("general.show_more_data"),
                OnClick: () => {
                    setIsModalOpen(true);
                },
                TestId: "tool-selectcard-tooldetail-showmoredata-button",
                Variant: "blueButton",
            }), createElement(ModalSheet, (Title = t("general.documents"), {
                CloseButtonTestId: "",
                Content: createElement(DocumentTable, {
                    AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto_1) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: DocumentId__get_unwrap(dto_1.Id),
                    })])), "none", "button")),
                    Documents: props.Documents,
                    OnDownloadFile: (tupledArg_1) => {
                        props.Dispatch(new Msg(19, [tupledArg_1[0], tupledArg_1[1]]));
                    },
                    UploadSuccessCallback: () => {
                        props.Dispatch(new Msg(18, []));
                    },
                    UploadType: new UploadType_2(1, [props.ConsumableId]),
                    UserData: props.UserData,
                }),
                Controls: empty_1(),
                IsModalOpen: patternInput_1[0],
                OnClose: () => {
                    setIsModalOpen(false);
                },
                Title: unwrap(Title),
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function HistorySection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsHistoryModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setAssignmentProtocolParams = patternInput_2[1];
    const table = (rows) => {
        let TableRows;
        return createElement(Table, (TableRows = toArray(rows), {
            ColumnDefinitions: [new ColumnDefinition$1("timestamp", "", t("general.date"), (dto) => (new CellContent(7, [dto.Timestamp])), "none", "dateTime"), new ColumnDefinition$1("eventType", "", t("general.event"), (dto_1) => (new CellContent(0, [t(Helper_historyTypeToTranslationString(dto_1.EventType))])), "select", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (dto_2) => (new CellContent(0, [dto_2.Quantity.toString()])), "text", "text"), new ColumnDefinition$1("commission", "", t("general.commission"), (dto_3) => (new CellContent(0, [dto_3.CommissionNumber])), "text", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_4) => {
                const matchValue = dto_4.Event;
                return (matchValue == null) ? (new CellContent(0, [t(dto_4.Comment)])) : (new CellContent(0, [Helper_displayHistoryComment(t(matchValue), dto_4.Comment)]));
            }, "none", "text"), new ColumnDefinition$1("receiver", "", t("general.receiver"), (dto_5) => {
                let matchValue_1;
                return new CellContent(0, [(matchValue_1 = dto_5.ReceiverInformation, (matchValue_1 == null) ? "" : matchValue_1.Name)]);
            }, "text", "text"), new ColumnDefinition$1("sender", "", t("general.sender"), (dto_6) => (new CellContent(0, [dto_6.SenderInformation.Name])), "text", "text"), new ColumnDefinition$1("signatureUrl", "", t("general.signature"), (dto_7) => {
                let matchValue_2;
                return new CellContent(4, [(matchValue_2 = dto_7.ReceiverInformation, (matchValue_2 != null) ? defaultArg(map_1((x) => x, matchValue_2.SignatureUrl), "") : "")]);
            }, "none", "image"), new ColumnDefinition$1("storage", "", t("general.storage"), (dto_8) => (new CellContent(0, [defaultArg(map_1((storage) => storage.Name, dto_8.StorageInformation), "")])), "text", "text"), new ColumnDefinition$1("action", "", "", (dto_9) => {
                const matchValue_3 = dto_9.EventType;
                switch (matchValue_3) {
                    case "updatedStock":
                    case "updatedStorage":
                    case "stocktakingStorageCorrectionBooking":
                    case "changeInformation":
                    case "activate":
                    case "retire":
                        return new CellContent(0, [""]);
                    default:
                        return new CellContent(2, [t("assignment_protocol.open_assignment_protocol"), () => {
                            let AssignmentType, ReceiverName, StorageName, SignatureUrl, ImageUrl;
                            setAssignmentProtocolParams((AssignmentType = t(Helper_historyTypeToTranslationString(dto_9.EventType)), (ReceiverName = defaultArg(map_1((_arg_1) => _arg_1.Name, dto_9.ReceiverInformation), ""), (StorageName = map_1((_arg_2) => _arg_2.Name, dto_9.StorageInformation), (SignatureUrl = flatten(map_1((_arg_3) => _arg_3.SignatureUrl, dto_9.ReceiverInformation)), (ImageUrl = ((props.BusinessUnitImageUrl == null) ? props.CustomerConfiguration.ProtocolConfiguration.ImageUrl : props.BusinessUnitImageUrl), new AssignmentProtocolParams(AssignmentType, props.ConsumableName, props.InventoryNumber, dto_9.SenderInformation.Name, ReceiverName, props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.QrCodeIds ? (isEmpty(props.QrCodeIds) ? "" : reduce((list_1, code) => concat(list_1, ", ", ...code), props.QrCodeIds)) : undefined, StorageName, dto_9.Comment, undefined, SignatureUrl, dto_9.Timestamp, ImageUrl, dto_9.SenderImageUrls, dto_9.ReceiverImageUrls)))))));
                        }]);
                }
            }, "none", "text")],
            Controls: empty_1(),
            Options: {
                BorderStyle: "row",
                CSVDownload: true,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["timestamp", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows,
        }));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(AssignmentProtocolDialog, {
        AssignmentProtocolParams: unwrap(patternInput_2[0]),
        OnClose: () => {
            setAssignmentProtocolParams(undefined);
        },
    })), delay(() => append(singleton(table((length(props.HistoryRows) > 5) ? take(5, props.HistoryRows) : props.HistoryRows)), delay(() => {
        let elems;
        return (length(props.HistoryRows) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsHistoryModalOpen(true);
            },
            TestId: "consumable-masterdata-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, {
            CloseButtonTestId: "",
            Content: table(props.HistoryRows),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsHistoryModalOpen(false);
            },
            Title: t("history.title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function StockSection(props) {
    let elems;
    const t = useTranslation()[0];
    let responsibleStorageIds;
    const matchValue = props.UserData.Role;
    switch (matchValue) {
        case "toolManager": {
            responsibleStorageIds = map((storage_1) => unwrapStorageId(storage_1.Id), filter((s) => contains(props.UserData.UserId, s.AssignedUserIds, {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }), props.Storages));
            break;
        }
        case "user": {
            responsibleStorageIds = empty_1();
            break;
        }
        default:
            responsibleStorageIds = map((storage) => unwrapStorageId(storage.Id), props.Storages);
    }
    const containsStorageId = (storageId) => contains(storageId, responsibleStorageIds, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    });
    const patternInput_1 = reactApi.useState(undefined);
    const setIsDeleteStockPerStorageDialogOpen = patternInput_1[1];
    const isDeleteStockPerStorageDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setIsMinimumStockQuantityDialogOpen = patternInput_2[1];
    const isMinimumStockQuantityDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setIsStockChangeDialogOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(undefined);
    const setIsChangeStorageSpaceDialogOpen = patternInput_4[1];
    const isChangeStorageSpaceDialogOpen = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const setIsChangeStorageDialogOpen = patternInput_5[1];
    const isChangeStorageDialogOpen = patternInput_5[0];
    const patternInput_6 = reactApi.useState(false);
    const setIsStockAddDialogOpen = patternInput_6[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = toList(delay(() => {
        let matchValue_8, selectedStorage, matchValue_9, selectedStorage_2;
        return append((matchValue_8 = patternInput_3[0], (matchValue_8 == null) ? (empty()) : ((selectedStorage = matchValue_8, (matchValue_9 = selectedStorage[1], (matchValue_9 == null) ? (empty()) : ((selectedStorage_2 = matchValue_9, singleton(createElement(ChangeStockDialog, {
            ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
            IsOpen: selectedStorage[0],
            OnClose: () => {
                setIsStockChangeDialogOpen(undefined);
            },
            StorageId: selectedStorage_2,
            Storages: filter((storage_2) => containsStorageId(unwrapStorageId(storage_2.Id)), props.Storages),
            SuccessCallback: () => {
                props.Dispatch(new Msg(2, []));
            },
        })))))))), delay(() => append(singleton(createElement(StockAddDialog, {
            ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
            IsOpen: patternInput_6[0],
            OnClose: () => {
                setIsStockAddDialogOpen(false);
            },
            Storages: filter((storage_3) => containsStorageId(unwrapStorageId(storage_3.Id)), props.Storages),
            SuccessCallback: () => {
                props.Dispatch(new Msg(2, []));
            },
        })), delay(() => {
            let matchValue_10, selectedStorageSpace, selectedStorage_3, IsOpen;
            return append((matchValue_10 = isChangeStorageSpaceDialogOpen, (matchValue_10 == null) ? (empty()) : ((selectedStorageSpace = matchValue_10[0], (selectedStorage_3 = matchValue_10[1], singleton(createElement(ChangeStorageSpaceDialog, (IsOpen = (isChangeStorageSpaceDialogOpen != null), {
                ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                IsEditableForUser: true,
                IsOpen: IsOpen,
                OnClose: () => {
                    setIsChangeStorageSpaceDialogOpen(undefined);
                },
                StorageId: new StorageId_2(parse(selectedStorage_3)),
                StorageSpace: selectedStorageSpace,
                SuccessCallback: () => {
                    props.Dispatch(new Msg(2, []));
                },
            }))))))), delay(() => {
                let matchValue_11;
                return append((matchValue_11 = isChangeStorageDialogOpen, (matchValue_11 == null) ? (empty()) : singleton(createElement(SwitchStorageDialog, {
                    Consumable: props.Consumable,
                    IsOpen: isChangeStorageDialogOpen != null,
                    OnClose: () => {
                        setIsChangeStorageDialogOpen(undefined);
                    },
                    SelectedSourceStorageId: matchValue_11,
                    Storages: filter((storage_4) => containsStorageId(unwrapStorageId(storage_4.Id)), props.Storages),
                    SuccessCallback: () => {
                        props.Dispatch(new Msg(2, []));
                    },
                    UserId: props.UserData.UserId,
                }))), delay(() => {
                    let matchValue_12, selectedStorage_4, IsOpen_2;
                    return append((matchValue_12 = isMinimumStockQuantityDialogOpen, (matchValue_12 == null) ? (empty()) : ((selectedStorage_4 = matchValue_12, singleton(createElement(MinimumStockQuantityDialog, (IsOpen_2 = (isMinimumStockQuantityDialogOpen != null), {
                        ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                        IsOpen: IsOpen_2,
                        OnClose: () => {
                            setIsMinimumStockQuantityDialogOpen(undefined);
                        },
                        StorageId: selectedStorage_4,
                        SuccessCallback: () => {
                            props.Dispatch(new Msg(2, []));
                        },
                    })))))), delay(() => {
                        let matchValue_13, selectedStorage_5, IsOpen_3;
                        return append((matchValue_13 = isDeleteStockPerStorageDialogOpen, (matchValue_13 == null) ? (empty()) : ((selectedStorage_5 = matchValue_13, singleton(createElement(ConsumablesStockPerStorageDeleteDialog, (IsOpen_3 = (isDeleteStockPerStorageDialogOpen != null), {
                            ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                            IsOpen: IsOpen_3,
                            OnClose: () => {
                                setIsDeleteStockPerStorageDialogOpen(undefined);
                            },
                            StorageId: selectedStorage_5,
                            SuccessCallback: () => {
                                props.Dispatch(new Msg(2, []));
                            },
                        })))))), delay(() => {
                            let TableRows, Options, matchValue_2;
                            return singleton(createElement(Table, (TableRows = toArray(props.Consumable.StockPerStorage), (Options = {
                                BorderStyle: "row",
                                CSVDownload: false,
                                ConfigurableColumns: false,
                                CustomTableFilters: false,
                                DefaultSortColumn: ["storage", "asc"],
                                Fullscreen: false,
                                GlobalSearch: false,
                                RowSelection: "singleRow",
                                SaveTableConfiguration: false,
                            }, {
                                ColumnDefinitions: [new ColumnDefinition$1("storage", "", t("general.storage"), (dto) => (new CellContent(0, [dto.StorageName])), "none", "text"), new ColumnDefinition$1("location", "", t("consumable.storage_space"), (dto_1) => (new CellContent(0, [t(dto_1.StorageSpace)])), "none", "text"), new ColumnDefinition$1("isStockTrackingEnabled", "", t("consumable.stock_tracking_enabled"), (dto_2) => (dto_2.IsStockTrackingEnabled ? (new CellContent(0, [t("general.yes")])) : (new CellContent(0, [t("general.no")]))), "none", "text"), new ColumnDefinition$1("quantity", "", t("general.stock"), (dto_3) => (!dto_3.IsStockTrackingEnabled ? (new CellContent(0, [""])) : (new CellContent(0, [dto_3.Stock.toString()]))), "none", "text"), new ColumnDefinition$1("minimum_quantity", "", t("general.minimum_quantity"), (dto_4) => {
                                    if (!dto_4.IsStockTrackingEnabled) {
                                        return new CellContent(0, [""]);
                                    }
                                    else {
                                        const matchValue_1 = dto_4.MinimumStockQuantity;
                                        if (matchValue_1 != null) {
                                            const minimumstockQuantity = matchValue_1;
                                            return new CellContent(0, [minimumstockQuantity.toString()]);
                                        }
                                        else {
                                            return new CellContent(0, [""]);
                                        }
                                    }
                                }, "none", "text"), new ColumnDefinition$1("qrcode", "", t("general.qr_code"), (dto_5) => (new CellContent(0, [isEmpty(dto_5.QRCodeIds) ? "" : reduce((e1, e2) => concat(e1, ", ", ...e2), map((e) => e, dto_5.QRCodeIds))])), "none", "text")],
                                Controls: (matchValue_2 = props.UserData.Role, (matchValue_2 === "system") ? ofArray([new TableControl$1(t("consumable.dialogs.stock_add_dialog.title"), Warehouse_1(), (_arg) => {
                                    setIsStockAddDialogOpen(true);
                                }, false, false, ""), new TableControl$1(t("tool.update_stock"), Warehouse_1(), (selectedSps) => {
                                    if (isEmpty(selectedSps)) {
                                        setIsStockChangeDialogOpen([true, undefined]);
                                    }
                                    else {
                                        const matchValue_3 = tryHead(map((selectedTool) => selectedTool.StorageId, selectedSps));
                                        if (matchValue_3 == null) {
                                        }
                                        else {
                                            const selectedStorageId_1 = matchValue_3;
                                            if (containsStorageId(selectedStorageId_1)) {
                                                setIsStockChangeDialogOpen([true, new StorageId_2(parse(selectedStorageId_1))]);
                                            }
                                        }
                                    }
                                }, true, false, ""), new TableControl$1(t("tool.change_storage_space"), Location_Building_Search(), (selectedSps_1) => {
                                    if (isEmpty(selectedSps_1)) {
                                    }
                                    else {
                                        const matchValue_4 = tryHead(map((selectedTool_1) => [selectedTool_1.StorageSpace, selectedTool_1.StorageId], selectedSps_1));
                                        if (matchValue_4 == null) {
                                        }
                                        else {
                                            const selectedStorageId_3 = matchValue_4;
                                            if (containsStorageId(selectedStorageId_3[1])) {
                                                setIsChangeStorageSpaceDialogOpen(selectedStorageId_3);
                                            }
                                        }
                                    }
                                }, true, false, ""), new TableControl$1(t("tool.switch_storage"), Transfer_Cart(), (selectedSps_2) => {
                                    if (isEmpty(selectedSps_2)) {
                                    }
                                    else {
                                        const matchValue_5 = tryHead(map((selectedStockPerStorage) => selectedStockPerStorage.StorageId, selectedSps_2));
                                        if (matchValue_5 == null) {
                                        }
                                        else {
                                            const selectedStorageId_5 = matchValue_5;
                                            if (containsStorageId(selectedStorageId_5)) {
                                                setIsChangeStorageDialogOpen(selectedStorageId_5);
                                            }
                                        }
                                    }
                                }, false, false, ""), new TableControl$1(t("general.minimum_quantity_update"), Notification_Alarm_1(), (selectedSps_3) => {
                                    if (isEmpty(selectedSps_3)) {
                                    }
                                    else {
                                        const matchValue_6 = tryHead(map((selectedTool_2) => selectedTool_2.StorageId, selectedSps_3));
                                        if (matchValue_6 == null) {
                                        }
                                        else {
                                            const selectedStorageId_7 = matchValue_6;
                                            if (containsStorageId(selectedStorageId_7)) {
                                                setIsMinimumStockQuantityDialogOpen(new StorageId_2(parse(selectedStorageId_7)));
                                            }
                                        }
                                    }
                                }, true, false, ""), new TableControl$1(t("general.delete"), Recycle_Bin_1(), (selectedSps_4) => {
                                    if (isEmpty(selectedSps_4)) {
                                    }
                                    else {
                                        const matchValue_7 = tryHead(map((selectedTool_3) => selectedTool_3.StorageId, selectedSps_4));
                                        if (matchValue_7 == null) {
                                        }
                                        else {
                                            const selectedStorageId_9 = matchValue_7;
                                            if (containsStorageId(selectedStorageId_9)) {
                                                setIsDeleteStockPerStorageDialogOpen(new StorageId_2(parse(selectedStorageId_9)));
                                            }
                                        }
                                    }
                                }, true, false, "")]) : ((matchValue_2 === "toolManager") ? ofArray([new TableControl$1(t("consumable.dialogs.stock_add_dialog.title"), Warehouse_1(), (_arg) => {
                                    setIsStockAddDialogOpen(true);
                                }, false, false, ""), new TableControl$1(t("tool.update_stock"), Warehouse_1(), (selectedSps) => {
                                    if (isEmpty(selectedSps)) {
                                        setIsStockChangeDialogOpen([true, undefined]);
                                    }
                                    else {
                                        const matchValue_3 = tryHead(map((selectedTool) => selectedTool.StorageId, selectedSps));
                                        if (matchValue_3 == null) {
                                        }
                                        else {
                                            const selectedStorageId_1 = matchValue_3;
                                            if (containsStorageId(selectedStorageId_1)) {
                                                setIsStockChangeDialogOpen([true, new StorageId_2(parse(selectedStorageId_1))]);
                                            }
                                        }
                                    }
                                }, true, false, ""), new TableControl$1(t("tool.change_storage_space"), Location_Building_Search(), (selectedSps_1) => {
                                    if (isEmpty(selectedSps_1)) {
                                    }
                                    else {
                                        const matchValue_4 = tryHead(map((selectedTool_1) => [selectedTool_1.StorageSpace, selectedTool_1.StorageId], selectedSps_1));
                                        if (matchValue_4 == null) {
                                        }
                                        else {
                                            const selectedStorageId_3 = matchValue_4;
                                            if (containsStorageId(selectedStorageId_3[1])) {
                                                setIsChangeStorageSpaceDialogOpen(selectedStorageId_3);
                                            }
                                        }
                                    }
                                }, true, false, ""), new TableControl$1(t("tool.switch_storage"), Transfer_Cart(), (selectedSps_2) => {
                                    if (isEmpty(selectedSps_2)) {
                                    }
                                    else {
                                        const matchValue_5 = tryHead(map((selectedStockPerStorage) => selectedStockPerStorage.StorageId, selectedSps_2));
                                        if (matchValue_5 == null) {
                                        }
                                        else {
                                            const selectedStorageId_5 = matchValue_5;
                                            if (containsStorageId(selectedStorageId_5)) {
                                                setIsChangeStorageDialogOpen(selectedStorageId_5);
                                            }
                                        }
                                    }
                                }, false, false, ""), new TableControl$1(t("general.minimum_quantity_update"), Notification_Alarm_1(), (selectedSps_3) => {
                                    if (isEmpty(selectedSps_3)) {
                                    }
                                    else {
                                        const matchValue_6 = tryHead(map((selectedTool_2) => selectedTool_2.StorageId, selectedSps_3));
                                        if (matchValue_6 == null) {
                                        }
                                        else {
                                            const selectedStorageId_7 = matchValue_6;
                                            if (containsStorageId(selectedStorageId_7)) {
                                                setIsMinimumStockQuantityDialogOpen(new StorageId_2(parse(selectedStorageId_7)));
                                            }
                                        }
                                    }
                                }, true, false, ""), new TableControl$1(t("general.delete"), Recycle_Bin_1(), (selectedSps_4) => {
                                    if (isEmpty(selectedSps_4)) {
                                    }
                                    else {
                                        const matchValue_7 = tryHead(map((selectedTool_3) => selectedTool_3.StorageId, selectedSps_4));
                                        if (matchValue_7 == null) {
                                        }
                                        else {
                                            const selectedStorageId_9 = matchValue_7;
                                            if (containsStorageId(selectedStorageId_9)) {
                                                setIsDeleteStockPerStorageDialogOpen(new StorageId_2(parse(selectedStorageId_9)));
                                            }
                                        }
                                    }
                                }, true, false, "")]) : ((matchValue_2 === "user") ? empty_1() : ofArray([new TableControl$1(t("consumable.dialogs.stock_add_dialog.title"), Warehouse_1(), (_arg) => {
                                    setIsStockAddDialogOpen(true);
                                }, false, false, ""), new TableControl$1(t("tool.update_stock"), Warehouse_1(), (selectedSps) => {
                                    if (isEmpty(selectedSps)) {
                                        setIsStockChangeDialogOpen([true, undefined]);
                                    }
                                    else {
                                        const matchValue_3 = tryHead(map((selectedTool) => selectedTool.StorageId, selectedSps));
                                        if (matchValue_3 == null) {
                                        }
                                        else {
                                            const selectedStorageId_1 = matchValue_3;
                                            if (containsStorageId(selectedStorageId_1)) {
                                                setIsStockChangeDialogOpen([true, new StorageId_2(parse(selectedStorageId_1))]);
                                            }
                                        }
                                    }
                                }, true, false, ""), new TableControl$1(t("tool.change_storage_space"), Location_Building_Search(), (selectedSps_1) => {
                                    if (isEmpty(selectedSps_1)) {
                                    }
                                    else {
                                        const matchValue_4 = tryHead(map((selectedTool_1) => [selectedTool_1.StorageSpace, selectedTool_1.StorageId], selectedSps_1));
                                        if (matchValue_4 == null) {
                                        }
                                        else {
                                            const selectedStorageId_3 = matchValue_4;
                                            if (containsStorageId(selectedStorageId_3[1])) {
                                                setIsChangeStorageSpaceDialogOpen(selectedStorageId_3);
                                            }
                                        }
                                    }
                                }, true, false, ""), new TableControl$1(t("tool.switch_storage"), Transfer_Cart(), (selectedSps_2) => {
                                    if (isEmpty(selectedSps_2)) {
                                    }
                                    else {
                                        const matchValue_5 = tryHead(map((selectedStockPerStorage) => selectedStockPerStorage.StorageId, selectedSps_2));
                                        if (matchValue_5 == null) {
                                        }
                                        else {
                                            const selectedStorageId_5 = matchValue_5;
                                            if (containsStorageId(selectedStorageId_5)) {
                                                setIsChangeStorageDialogOpen(selectedStorageId_5);
                                            }
                                        }
                                    }
                                }, false, false, ""), new TableControl$1(t("general.minimum_quantity_update"), Notification_Alarm_1(), (selectedSps_3) => {
                                    if (isEmpty(selectedSps_3)) {
                                    }
                                    else {
                                        const matchValue_6 = tryHead(map((selectedTool_2) => selectedTool_2.StorageId, selectedSps_3));
                                        if (matchValue_6 == null) {
                                        }
                                        else {
                                            const selectedStorageId_7 = matchValue_6;
                                            if (containsStorageId(selectedStorageId_7)) {
                                                setIsMinimumStockQuantityDialogOpen(new StorageId_2(parse(selectedStorageId_7)));
                                            }
                                        }
                                    }
                                }, true, false, ""), new TableControl$1(t("general.delete"), Recycle_Bin_1(), (selectedSps_4) => {
                                    if (isEmpty(selectedSps_4)) {
                                    }
                                    else {
                                        const matchValue_7 = tryHead(map((selectedTool_3) => selectedTool_3.StorageId, selectedSps_4));
                                        if (matchValue_7 == null) {
                                        }
                                        else {
                                            const selectedStorageId_9 = matchValue_7;
                                            if (containsStorageId(selectedStorageId_9)) {
                                                setIsDeleteStockPerStorageDialogOpen(new StorageId_2(parse(selectedStorageId_9)));
                                            }
                                        }
                                    }
                                }, true, false, "")])))),
                                Options: Options,
                                TableKey: "not-defined-table",
                                TableRows: TableRows,
                            }))));
                        }));
                    }));
                }));
            }));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function BarcodeSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    let tableData;
    const list_6 = collect((x) => x, map((stockPerStorage) => choose((qrCodeId) => ({
        QrCode: qrCodeId,
        StorageId: new StorageId_2(parse(stockPerStorage.StorageId)),
        StorageName: stockPerStorage.StorageName,
        StorageSpace: stockPerStorage.StorageSpace,
    }), stockPerStorage.QRCodeIds), props.StockPerStorage));
    tableData = append_1(choose((stockPerStorage_2) => ({
        QrCode: "",
        StorageId: new StorageId_2(parse(stockPerStorage_2.StorageId)),
        StorageName: stockPerStorage_2.StorageName,
        StorageSpace: stockPerStorage_2.StorageSpace,
    }), filter((stockPerStorage_1) => isEmpty(stockPerStorage_1.QRCodeIds), props.StockPerStorage)), list_6);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(QrCodeTableWithStorage, {
        Data: (length(tableData) > 5) ? take(5, tableData) : tableData,
        OnAssignQrCode: (tupledArg) => {
            props.Dispatch(new Msg(10, [tupledArg[0], tupledArg[1]]));
        },
        OnDeleteQrCodes: (tupledArg_1) => {
            props.Dispatch(new Msg(12, [tupledArg_1[0], tupledArg_1[1]]));
        },
        UserData: props.UserData,
    })), delay(() => {
        let elems, Title;
        return (length(tableData) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, (Title = t("general.qr_code"), {
            CloseButtonTestId: "",
            Content: createElement(QrCodeTableWithStorage, {
                Data: tableData,
                OnAssignQrCode: (value_2) => {
                },
                OnDeleteQrCodes: (value_3) => {
                },
                UserData: props.UserData,
            }),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: unwrap(Title),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ConsumableDetailOverview(props) {
    let elems_13, elems_12, elems, cats, matchValue, matchValue_1, matchValue_2, elems_1, elems_11, elems_10;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsDeleteDialogOpen = patternInput_1[1];
    const isDeleteDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState("consumable-overview-section");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "grow", "flex-col"])], (elems_13 = [createElement(ConsumableDeleteDialog, {
        ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
        IsOpen: isDeleteDialogOpen,
        OnClose: () => {
            setIsDeleteDialogOpen(false);
        },
        SuccessCallback: () => {
            RouterModule_nav(ofArray(["consumables"]), 1, 1);
        },
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,min(calc(100vw-16rem-2px-28px-11rem),80rem)]", "print:flex", "print:flex-col"])], (elems_12 = [reactElement("div", createObj(ofArray([["className", join(" ", ["col-span-2"])], (elems = [createElement(DetailViewHeader, {
        Badges: (cats = props.Consumable.Categories, map((leaf) => createElement(Badge, {
            Color: leaf.ColorHex,
            Label: join(" > ", ofArray(split(leaf.CategoryName, [" > "], undefined, 0))),
            TestId: concat("category-badge-", ...leaf.CategoryId),
        }), filter((c) => !exists((o) => {
            if (o.CategoryName !== c.CategoryName) {
                return o.CategoryName.startsWith(c.CategoryName + " > ");
            }
            else {
                return false;
            }
        }, cats), cats))),
        OnBack: () => {
            RouterModule_nav(singleton_1("consumables" + RouterModule_encodeQueryString(getQueryParams(undefined))), 1, 1);
        },
        OnDelete: unwrap((matchValue = props.UserData.Role, (matchValue === "system") ? (() => {
            setIsDeleteDialogOpen(!isDeleteDialogOpen);
        }) : ((matchValue === "toolManager") ? (props.CustomerConfiguration.InventoryConfiguration.ToolManagerCanDeleteInventory ? (() => {
            setIsDeleteDialogOpen(!isDeleteDialogOpen);
        }) : undefined) : ((matchValue === "user") ? undefined : (() => {
            setIsDeleteDialogOpen(!isDeleteDialogOpen);
        }))))),
        OnDuplicate: unwrap((matchValue_1 = props.UserData.Role, (matchValue_1 === "system") ? (() => {
            RouterModule_nav(ofArray(["consumables", props.Consumable.Id, "copy" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : ((matchValue_1 === "toolManager") ? (() => {
            RouterModule_nav(ofArray(["consumables", props.Consumable.Id, "copy" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : ((matchValue_1 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["consumables", props.Consumable.Id, "copy" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }))))),
        OnEdit: unwrap((matchValue_2 = props.UserData.Role, (matchValue_2 === "system") ? (() => {
            RouterModule_nav(ofArray(["consumables", props.Consumable.Id, "edit" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : ((matchValue_2 === "toolManager") ? (() => {
            RouterModule_nav(ofArray(["consumables", props.Consumable.Id, "edit" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : ((matchValue_2 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["consumables", props.Consumable.Id, "edit" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }))))),
        Title: props.Consumable.MasterData.Name,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["print:hidden"])], (elems_1 = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => append(singleton({
            Id: "consumable-overview-section",
            Label: t("general.overview"),
        }), delay(() => append(singleton({
            Id: "consumable-masterdata-section",
            Label: t("general.master_data"),
        }), delay(() => append(isFeatureEnabled(new Feature(12, [])) ? append(singleton({
            Id: "appointments-section-id",
            Label: t("general.appointments"),
        }), delay(() => singleton({
            Id: "reservations-section-id",
            Label: t("navbar.reservation"),
        }))) : empty(), delay(() => append(singleton({
            Id: "consumable-stock-section",
            Label: t("general.stock"),
        }), delay(() => append(singleton({
            Id: "consumable-documents-section",
            Label: t("general.documents"),
        }), delay(() => append(singleton({
            Id: "barcodes-section-id",
            Label: t("general.qr_code"),
        }), delay(() => {
            const matchValue_3 = props.UserData.Role;
            switch (matchValue_3) {
                case "user": {
                    return empty();
                }
                default:
                    return singleton({
                        Id: "history-section-id",
                        Label: t("general.history"),
                    });
            }
        })))))))))))))),
        OnSelectAnchor: patternInput_2[1],
        SelectedAnchor: patternInput_2[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(singleton_1((elems_11 = [reactElement("div", createObj(singleton_1((elems_10 = toList(delay(() => {
        let elems_2;
        return append(singleton(reactElement("div", createObj(ofArray([["id", "consumable-overview-section"], (elems_2 = [createElement(OverviewSection, {
            AccountSettings: props.AccountSettings,
            Consumable: props.Consumable,
            ConsumableImages: props.ConsumableImages,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            Notifications: props.Notifications,
            QuickOverviewDialog: props.QuickOverviewDialog,
            Storages: props.Storages,
            UserConfiguration: props.UserConfiguration,
            UserData: props.UserData,
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_3, Title_1;
            return append(singleton(reactElement("section", createObj(ofArray([["id", "consumable-masterdata-section"], (elems_3 = [createElement(SectionContainer, (Title_1 = t("general.master_data"), {
                Content: createElement(MasterDataSection, {
                    AccountSettings: props.AccountSettings,
                    Consumable: props.Consumable,
                    Currency: props.CustomerConfiguration.Currency,
                }),
                Title: unwrap(Title_1),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_4, Title_2;
                return append(isFeatureEnabled(new Feature(12, [])) ? singleton(reactElement("section", createObj(ofArray([["id", "appointments-section-id"], (elems_4 = [createElement(TableContainer, (Title_2 = t("general.appointments"), {
                    Content: createElement(AppointmentSection, {
                        Consumable: props.Consumable,
                        Dispatch: props.Dispatch,
                        Documents: props.Documents,
                        ReceiverNames: empty_1(),
                        UserData: props.UserData,
                    }),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty(), delay(() => {
                    let elems_5, Title_3;
                    return append(isFeatureEnabled(new Feature(12, [])) ? singleton(reactElement("section", createObj(ofArray([["id", "reservations-section-id"], (elems_5 = [createElement(TableContainer, (Title_3 = t("navbar.reservation"), {
                        Content: createElement(ReservationSection, {
                            Consumable: props.Consumable,
                            Dispatch: props.Dispatch,
                            ReceiverNames: empty_1(),
                            UserData: props.UserData,
                        }),
                        Title: unwrap(Title_3),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty(), delay(() => {
                        let elems_6, Title_4;
                        return append(singleton(reactElement("section", createObj(ofArray([["id", "consumable-stock-section"], (elems_6 = [createElement(TableContainer, (Title_4 = t("general.stock"), {
                            Content: createElement(StockSection, {
                                Consumable: props.Consumable,
                                Dispatch: props.Dispatch,
                                Storages: props.Storages,
                                UserData: props.UserData,
                            }),
                            Title: unwrap(Title_4),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                            let elems_7, Title_5;
                            return append(singleton(reactElement("section", createObj(ofArray([["id", "consumable-documents-section"], (elems_7 = [createElement(TableContainer, (Title_5 = t("general.documents"), {
                                Content: createElement(DocumentSection, {
                                    ConsumableId: new ConsumableId_1(parse(props.Consumable.Id)),
                                    Dispatch: props.Dispatch,
                                    Documents: props.Documents,
                                    IsVisibleForUser: true,
                                    UserData: props.UserData,
                                }),
                                Title: unwrap(Title_5),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                                let elems_8, Title_6;
                                return append(singleton(reactElement("section", createObj(ofArray([["id", "barcodes-section-id"], (elems_8 = [createElement(TableContainer, (Title_6 = t("general.qr_code"), {
                                    Content: createElement(BarcodeSection, {
                                        Dispatch: props.Dispatch,
                                        StockPerStorage: props.Consumable.StockPerStorage,
                                        Storages: props.Storages,
                                        UserData: props.UserData,
                                    }),
                                    Title: unwrap(Title_6),
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                                    let elems_9, Title_7, Title_8, Title_9, matchValue_5;
                                    const matchValue_4 = props.UserData.Role;
                                    switch (matchValue_4) {
                                        case "user": {
                                            return empty();
                                        }
                                        default:
                                            return singleton(reactElement("section", createObj(ofArray([["id", "history-section-id"], (elems_9 = [createElement(TableContainerWithTabs, (Title_7 = t("history.title"), {
                                                Tab1: (Title_8 = t("history.events"), {
                                                    Content: createElement(HistorySection, {
                                                        BusinessUnitImageUrl: unwrap(props.BusinessUnitImageUrl),
                                                        ConsumableName: props.Consumable.MasterData.Name,
                                                        CustomerConfiguration: props.CustomerConfiguration,
                                                        HistoryRows: props.History,
                                                        InventoryNumber: props.Consumable.MasterData.InventoryNumber,
                                                        QrCodeIds: collect((x) => x, map((sps) => sps.QRCodeIds, props.Consumable.StockPerStorage)),
                                                    }),
                                                    Title: Title_8,
                                                }),
                                                Tab2: (Title_9 = t("history.changes"), {
                                                    Content: (matchValue_5 = props.Changelogs, (matchValue_5.tag === 0) ? createElement(Skeleton, {
                                                        Variant: "table",
                                                    }) : createElement(ChangelogTable, {
                                                        Changelogs: matchValue_5.fields[0],
                                                    })),
                                                    OnSelect: () => {
                                                        props.Dispatch(new Msg(28, []));
                                                    },
                                                    Title: Title_9,
                                                }),
                                                Title: unwrap(Title_7),
                                            }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))));
                                    }
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_10))]))))], ["children", reactApi.Children.toArray(Array.from(elems_11))]))))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
}

export function ConsumableDetailOverviewView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initViewConsumable(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.ConsumableId, props.UserData], undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Consumables;
    const matchValue_1 = state_1.History;
    const matchValue_2 = state_1.Documents;
    const matchValue_3 = state_1.UserConfiguration;
    const matchValue_4 = state_1.Storages;
    const matchValue_5 = state_1.Notifications;
    const matchValue_6 = state_1.CustomerConfiguration;
    const matchValue_7 = state_1.AccountSettings;
    const matchValue_8 = state_1.BusinessUnitImageUrl;
    let matchResult, accountSettings, businessUnitImageUrl, consumable, customerConfiguration, documents, history, notifications, storages, userConfiguration;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_7.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_8.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_7.fields[0];
        businessUnitImageUrl = matchValue_8.fields[0];
        consumable = matchValue.fields[0];
        customerConfiguration = matchValue_6.fields[0];
        documents = matchValue_2.fields[0];
        history = matchValue_1.fields[0];
        notifications = matchValue_5.fields[0];
        storages = matchValue_4.fields[0];
        userConfiguration = matchValue_3.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(ConsumableDetailOverview, {
                AccountSettings: accountSettings,
                BusinessUnitImageUrl: unwrap(businessUnitImageUrl),
                Changelogs: state_1.Changelogs,
                Consumable: consumable,
                ConsumableImages: state_1.ConsumableImages,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                Documents: documents,
                History: history,
                Notifications: notifications,
                QuickOverviewDialog: state_1.QuickOverviewDialog,
                Storages: storages,
                UserConfiguration: userConfiguration,
                UserData: state_1.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

